import React from "react";

const CPP_If = () => {
  return (
    <div>
      <h1>CPP_If Component</h1>
      <p>Content for CPP_If goes here...</p>
    </div>
  );
};

export default CPP_If;
